<template>
  <custom-section id="landing" source="Landing/Landing"/>
</template>
<script>
  import CustomSection from './CustomSection';

  export default {
    components: {CustomSection},
  };
</script>
<style lang="scss">
  #landing {
    .figure {
      margin: 0 !important;
      padding-right: 1rem;
    }

    .figure-caption {
      font-size: 60% !important;
      text-align: center;
    }
  }
</style>
